import { motion } from "framer-motion";

// Coordonnées relevées sur le logo officiel Deseos (5 rayons, angles 23,5° / 51° / 90°).
const RAYS = [
  { x1: 60, y1: 22.8, x2: 60, y2: 5.1 },
  { x1: 38.4, y1: 29.8, x2: 27.3, y2: 16.1 },
  { x1: 81.6, y1: 29.8, x2: 92.7, y2: 16.1 },
  { x1: 26.4, y1: 41.9, x2: 9.7, y2: 34.6 },
  { x1: 93.6, y1: 41.9, x2: 110.3, y2: 34.6 },
];

export const SunLogo = ({ animate = true, className = "", delay = 0.2 }) => {
  const on = animate ? "visible" : false;
  return (
    <svg
      viewBox="0 0 120 68"
      className={className}
      fill="none"
      stroke="#D9B98A"
      strokeWidth="2"
      strokeLinecap="round"
      aria-label="Deseos"
      role="img"
    >
      <motion.g initial={animate ? "hidden" : false} animate={on}>
        {RAYS.map((r, i) => (
          <motion.line
            key={i}
            {...r}
            variants={{ hidden: { pathLength: 0, opacity: 0 }, visible: { pathLength: 1, opacity: 1 } }}
            transition={{ duration: 0.5, delay: delay + 0.9 + i * 0.12, ease: "easeOut" }}
          />
        ))}
        <motion.path
          d="M32.9 56.5 A27.1 27.1 0 0 1 87.1 56.5"
          fill="#D9B98A"
          stroke="none"
          variants={{ hidden: { y: 26, opacity: 0 }, visible: { y: 0, opacity: 1 } }}
          transition={{ duration: 1.4, delay: delay + 0.45, ease: [0.22, 1, 0.36, 1] }}
          style={{ clipPath: "inset(0 0 0 0)" }}
        />
        <motion.line
          x1="8"
          y1="56.5"
          x2="112"
          y2="56.5"
          variants={{ hidden: { pathLength: 0 }, visible: { pathLength: 1 } }}
          transition={{ duration: 1.1, delay, ease: "easeInOut" }}
        />
      </motion.g>
    </svg>
  );
};
